import { Config } from '@/types/config'; // 引入类型定义
import devConfig from './config.dev.json';
import stageConfig from './config.stage.json';
import qaConfig from './config.qa.json';
import prodConfig from './config.prod.json';

type Environment = 'dev' | 'qa' | 'stage' | 'prod';
const env = (process.env.NEXT_PUBLIC_ENV || 'prod') as Environment; // 默认环境为 'prod'


const configs = {
  dev: devConfig,
  qa: qaConfig,
  stage: stageConfig,
  prod: prodConfig,
};

let currentConfig: Config;

try {
  // 使用动态导入加载 JSON 文件
  currentConfig = configs[env] as Config;
  currentConfig.CMS_AUTHORIZATION = process.env.CMS_AUTHORIZATION || '';
  currentConfig.NEXT_PUBLIC_BAIDU_MAP_KEY = process.env.NEXT_PUBLIC_BAIDU_MAP_KEY || ''
  currentConfig.QT_API_KEY = process.env.NEXT_PUBLIC_QT_KEY || ''
  currentConfig.X_API_KEY = process.env.NEXT_PUBLIC_X_API_KEY || ''
  currentConfig.RECALL_X_API_KEY =  process.env.NEXT_PUBLIC_RECALL_X_API_KEY || ''
} catch {
  throw new Error(`Failed to load configuration for environment: ${env}`);
}

export default currentConfig;
